import { FC } from 'react';
import useAuth from 'store/Auth/useAuth';
import { useUpdateProfileMutation } from 'store/_Api/Auth';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { ApiErrorShape } from 'models/error';
import LanguageSelect from 'components/LanguageSelect';
import toast from 'components/toast';
import './UserProfile.scss';

const UserProfile: FC = (): JSX.Element => {
  const { profile } = useAuth();
  const [updateProfile] = useUpdateProfileMutation();

  const handleChange = async (e) => {
    const selectedLang = e.target.value;
    if (selectedLang) {
      const res = await updateProfile({
        url: profile?.links?.update,
        body: {
          language: selectedLang,
        },
      });

      if ('error' in res) {
        console.error(res.error);
        const error = (res.error as FetchBaseQueryError)?.data;
        toast.error(
          ((error as ApiErrorShape)?.detail as string) ||
            'Unable to change the language at this time',
        );
        return;
      }

      toast.success('Language changed successfully.');
    }
  };

  return (
    <div className="profile-content">
      <LanguageSelect value={profile?.language} handleChange={handleChange} />
    </div>
  );
};

export default UserProfile;
